import { useParams } from 'react-router-dom';

import styled from 'styled-components';

import { Loader } from 'components/Loader';
import { ProductArrangementDetailsForm } from './ProductArrangementDetailsForm';

import { useGetAllProductsQuery, useGetProductArrangementQuery } from 'data/__generated__';

type ParamTypes = {
    productArrangementId: string;
};

export const ProductArrangementDetails = () => {
    const { productArrangementId = '' } = useParams<ParamTypes>();

    const {
        loading: productArrangementLoading,
        data: productArrangementData,
        error: productArrangementError,
    } = useGetProductArrangementQuery({
        variables: {
            productArrangementId,
        },
    });

    const { loading: productsLoading, data: productsData, error: productsError } = useGetAllProductsQuery();

    if (productArrangementLoading || productsLoading) {
        return (
            <Container>
                <Loader />
            </Container>
        );
    }

    if (productArrangementError || !productArrangementData || productsError || !productsData) {
        throw new Error('Une erreur est survenue lors de la récupération de le gamme de produits');
    }

    const { productArrangementQuery: productArrangement } = productArrangementData;
    const { getAllProducts: products } = productsData;

    return (
        <Container>
            <ProductArrangementDetailsForm productArrangement={productArrangement} products={products} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex: 1;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.textColor};
`;
